import React from "react";
import "./App.css";
import Home from "./component/home";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Moreprofile from "./component/Moreprofile";
import Moredetail from "./component/Moredetail";
import Dashboard from "./component/Dashboard";
import Login from "./component/Login";
import RegisterAndDetail from "./component/RegisterAndDetail";
import Settings from "./component/Settings";
import Notification from "./component/Notification";
import LikedProfiles from "./component/LikedProfiles";
import MyProfile from "./component/MyProfile";
import MembershipPlans from "./component/MembershipPlans";

const App = () => {

  return (
    <BrowserRouter>
      <Routes>
         {/* Default Route */}
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="*" element={<Navigate to="/login" />} />

        {/* Public Routes */}
        <Route path="/home" element={<Home />} />        
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterAndDetail />} />
        {/* Protected Routes */}
        <Route path="/rishteydashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Moreprofile />} />
        <Route path="/moredetail/:id" element={<Moredetail />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/setting" element={<Settings />} />
        <Route path="/liked" element={<LikedProfiles />} />
        <Route path="/notification" element={<Notification />} />
        <Route path="/membership" element={<MembershipPlans />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
